var map = {
	"./2.svg": [
		92238,
		2238
	],
	"./CloseIconRedCircle.svg": [
		30550,
		550
	],
	"./accountIcon.svg": [
		79491,
		9491
	],
	"./add-seller.svg": [
		41966,
		1966
	],
	"./addIconGray.svg": [
		30292,
		292
	],
	"./age.svg": [
		65520,
		5520
	],
	"./alertIcon.svg": [
		95194,
		5194
	],
	"./allNumberIconWhite.svg": [
		69656,
		9656
	],
	"./amazonIcon.svg": [
		7306,
		7306
	],
	"./amazon_ld_cu.svg": [
		82020,
		2020
	],
	"./amazon_logo_wob_lg.svg": [
		40000,
		0
	],
	"./arrow-btn.svg": [
		86894,
		6894
	],
	"./arrowDownIcon.svg": [
		37146,
		7146
	],
	"./arrowGreen.svg": [
		24759,
		4759
	],
	"./arrowGreenNotif.svg": [
		37697,
		7697
	],
	"./arrowRed.svg": [
		61288,
		1288
	],
	"./arrowSendIcon.svg": [
		64588,
		4588
	],
	"./arrow_w.svg": [
		62176,
		5777
	],
	"./attachBlueIcon.svg": [
		45428,
		5428
	],
	"./attachDark.svg": [
		98469,
		8469
	],
	"./attachIcon.svg": [
		30430,
		430
	],
	"./backIcon.svg": [
		7411,
		7411
	],
	"./backIconGreen.svg": [
		83862,
		3862
	],
	"./backIconWhite.svg": [
		39651,
		9651
	],
	"./barChart.svg": [
		86233,
		6233
	],
	"./basket-category.svg": [
		94309,
		4309
	],
	"./bellIcon.svg": [
		17769,
		7769
	],
	"./bookmark-fill.svg": [
		81106,
		3424
	],
	"./bookmark.svg": [
		51276,
		1276
	],
	"./bookmark_white.svg": [
		91306,
		1306
	],
	"./bookmark_white_s.svg": [
		1878,
		1878
	],
	"./boxChart.svg": [
		3028,
		3028
	],
	"./boxIcon.svg": [
		69357,
		9357
	],
	"./box_o.svg": [
		8038,
		8038
	],
	"./cal.svg": [
		85861,
		5861
	],
	"./calenderIconGray.svg": [
		76375,
		6375
	],
	"./calenderWhite.svg": [
		44680,
		4680
	],
	"./calender_gray_s.svg": [
		23619,
		3619
	],
	"./cameraIcon.svg": [
		10205,
		205
	],
	"./chartIcon.svg": [
		58060,
		8060
	],
	"./chartIconBlack.svg": [
		7917,
		7917
	],
	"./chart_ic.svg": [
		52467,
		2467
	],
	"./checkIcon.svg": [
		62862,
		2862
	],
	"./checkedIcon.svg": [
		75212,
		5212
	],
	"./checkmark.svg": [
		32206,
		2206
	],
	"./clickIconWhite.svg": [
		56142,
		6142
	],
	"./clockIcon.svg": [
		52380,
		2380
	],
	"./clockIconGray.svg": [
		83573,
		3573
	],
	"./closeCollapse.svg": [
		14396,
		4396
	],
	"./closeIcon.svg": [
		48659,
		8659
	],
	"./closeWhite.svg": [
		76241,
		6241
	],
	"./coin.svg": [
		48952,
		8952
	],
	"./comment-icon.svg": [
		65370,
		5370
	],
	"./commentIcon.svg": [
		97304,
		7304
	],
	"./comments-log.svg": [
		87652,
		7652
	],
	"./comments.svg": [
		90404,
		404
	],
	"./compare-icon.svg": [
		35546,
		5546
	],
	"./copyIconBlue.svg": [
		89445,
		9445
	],
	"./cross.svg": [
		5442,
		5442
	],
	"./cube.svg": [
		17498,
		7498
	],
	"./customer-club-route-icon.svg": [
		14810,
		4810
	],
	"./dashboardIcon.svg": [
		98758,
		8758
	],
	"./dashboardIconActive.svg": [
		58612,
		8612
	],
	"./dateIcon.svg": [
		66566,
		6566
	],
	"./deleteIconDark.svg": [
		9654,
		9654
	],
	"./details-icon.svg": [
		48796,
		8796
	],
	"./dideban_logo_blue.svg": [
		94762,
		4762
	],
	"./disLikeIcon.svg": [
		10201,
		201
	],
	"./dislike.svg": [
		22493,
		2493
	],
	"./dislikeIconGray.svg": [
		9843,
		9843
	],
	"./dislikeRed.svg": [
		62781,
		2781
	],
	"./dislike_white.svg": [
		84315,
		4315
	],
	"./dislike_white_s.svg": [
		52992,
		2992
	],
	"./documentIcon.svg": [
		41162,
		1162
	],
	"./downloadFileIcon.svg": [
		61577,
		1577
	],
	"./downloadIcon.svg": [
		4281,
		4281
	],
	"./downloadIconBlack.svg": [
		52566,
		2566
	],
	"./drupdownIconDown.svg": [
		91763,
		1763
	],
	"./edit.svg": [
		221,
		221
	],
	"./editIcon.svg": [
		78049,
		6049
	],
	"./editIconBlue.svg": [
		1558,
		1558
	],
	"./editIconDark.svg": [
		9977,
		9977
	],
	"./editIconGray.svg": [
		86480,
		6480
	],
	"./editIconWhite.svg": [
		8482,
		8482
	],
	"./edit_or.svg": [
		20148,
		148
	],
	"./education.svg": [
		75141,
		5141
	],
	"./ellipsis-vertical-solid.svg": [
		72178,
		2178
	],
	"./emailIconWhite.svg": [
		30179,
		8049
	],
	"./emailNotifIcon.svg": [
		43353,
		3353
	],
	"./email_dash.svg": [
		19075,
		9075
	],
	"./emoji1.svg": [
		55721,
		5721
	],
	"./emoji2.svg": [
		49028,
		9028
	],
	"./emoji3.svg": [
		7292,
		7292
	],
	"./emoji4.svg": [
		22808,
		2808
	],
	"./emoji5.svg": [
		77044,
		7044
	],
	"./emoji_g.svg": [
		63108,
		3108
	],
	"./emptyStarIcon.svg": [
		69232,
		9232
	],
	"./england-flag.svg": [
		55543,
		5543
	],
	"./erthIconWhite.svg": [
		8407,
		8407
	],
	"./excelIcon.svg": [
		86377,
		6377
	],
	"./exel_ic_gr.svg": [
		47929,
		7929
	],
	"./exitpanelIcon.svg": [
		68695,
		8695
	],
	"./eye.svg": [
		14345,
		4345
	],
	"./eyeIcon.svg": [
		77296,
		7296
	],
	"./eye_white.svg": [
		93836,
		3836
	],
	"./eye_white_s.svg": [
		82994,
		2994
	],
	"./file_ic_vi.svg": [
		4297,
		4297
	],
	"./forum-icon.svg": [
		8124,
		8124
	],
	"./giftIcon.svg": [
		99190,
		112
	],
	"./google-btn.svg": [
		20254,
		254
	],
	"./gridViewIcon.svg": [
		96552,
		6552
	],
	"./gridViewIconBlue.svg": [
		3266,
		3266
	],
	"./hambergerIcon.svg": [
		39680,
		9680
	],
	"./home_blue.svg": [
		72295,
		2295
	],
	"./home_gray.svg": [
		90532,
		532
	],
	"./horizantalDots.svg": [
		26491,
		6491
	],
	"./imageIcon.svg": [
		83064,
		3064
	],
	"./iran-flag.svg": [
		13635,
		3635
	],
	"./item_sub.svg": [
		83531,
		3531
	],
	"./language.svg": [
		71106,
		1106
	],
	"./light_r copy.svg": [
		38351,
		8351
	],
	"./light_r.svg": [
		40341,
		341
	],
	"./like.svg": [
		42436,
		2436
	],
	"./likeGreen.svg": [
		7053,
		7053
	],
	"./likeIcon.svg": [
		21734,
		1734
	],
	"./like_white.svg": [
		85384,
		5384
	],
	"./list.svg": [
		80942,
		942
	],
	"./listViewIcons.svg": [
		62318,
		2318
	],
	"./listViewIconsBlue.svg": [
		40249,
		249
	],
	"./loca_dash.svg": [
		14186,
		4186
	],
	"./locationIcon.svg": [
		64859,
		4859
	],
	"./locationIconGray.svg": [
		61269,
		1269
	],
	"./locationIconWhite.svg": [
		83071,
		3071
	],
	"./lock.svg": [
		42335,
		2335
	],
	"./map-pin.svg": [
		2079,
		2079
	],
	"./messageIcon.svg": [
		26581,
		6581
	],
	"./message_b.svg": [
		22048,
		2048
	],
	"./message_berger_menu.svg": [
		97056,
		7056
	],
	"./min_red.svg": [
		29237,
		9237
	],
	"./minus-red.svg": [
		43121,
		3121
	],
	"./mokaabIconWhite.svg": [
		35160,
		5160
	],
	"./more_white.svg": [
		69569,
		9569
	],
	"./newIcon.svg": [
		26818,
		6818
	],
	"./notificationIcon.svg": [
		8484,
		8484
	],
	"./openCollapse.svg": [
		84435,
		4435
	],
	"./otherDotsIcon.svg": [
		46133,
		6133
	],
	"./otherDotsIconWhite.svg": [
		11900,
		1900
	],
	"./percentIcon.svg": [
		71266,
		7090
	],
	"./personIcon.svg": [
		78894,
		8894
	],
	"./person_v.svg": [
		53512,
		3512
	],
	"./person_white.svg": [
		25569,
		5569
	],
	"./phone.svg": [
		28187,
		8187
	],
	"./phoneIcon.svg": [
		84218,
		4218
	],
	"./phoneIconWhite.svg": [
		58530,
		8530
	],
	"./pic_ic_ba.svg": [
		77220,
		370
	],
	"./pin.svg": [
		71366,
		1366
	],
	"./plus-green.svg": [
		68470,
		8470
	],
	"./plusIcon.svg": [
		78946,
		8946
	],
	"./plusIconLarge.svg": [
		20462,
		462
	],
	"./plus_green.svg": [
		73703,
		3703
	],
	"./printIcon.svg": [
		67240,
		7240
	],
	"./rate_header copy.svg": [
		82692,
		2692
	],
	"./rate_header.svg": [
		18874,
		8874
	],
	"./rate_ic.svg": [
		71781,
		1781
	],
	"./ratingIcon.svg": [
		23574,
		3574
	],
	"./redCloseIcon.svg": [
		73798,
		3798
	],
	"./reportsIcon.svg": [
		54282,
		4282
	],
	"./resturant-menu.svg": [
		84048,
		4048
	],
	"./rocket_e.svg": [
		55471,
		5471
	],
	"./sandTimer.svg": [
		63471,
		3471
	],
	"./sandTimerDark.svg": [
		34033,
		4033
	],
	"./saveIcon.svg": [
		5607,
		5607
	],
	"./saveIconWhite.svg": [
		33018,
		3018
	],
	"./scale-up.svg": [
		77178,
		7178
	],
	"./scan_blue.svg": [
		13329,
		3329
	],
	"./scoreIcon.svg": [
		8012,
		8012
	],
	"./scoreIconGray.svg": [
		32785,
		2785
	],
	"./searchIcon.svg": [
		83175,
		3175
	],
	"./search_gray_s.svg": [
		63613,
		3613
	],
	"./search_ic_gr.svg": [
		79278,
		9278
	],
	"./seller.svg": [
		13710,
		3710
	],
	"./sendArrow.svg": [
		58925,
		8925
	],
	"./settingIcon.svg": [
		37664,
		7664
	],
	"./shareBlue.svg": [
		23598,
		3598
	],
	"./shareIcon.svg": [
		55364,
		5364
	],
	"./share_c.svg": [
		37982,
		7982
	],
	"./share_white.svg": [
		91129,
		1129
	],
	"./sidebar/basket.svg": [
		81384,
		1384
	],
	"./sidebar/bests.svg": [
		79996,
		9996
	],
	"./sidebar/club.svg": [
		26178,
		6178
	],
	"./sidebar/comment.svg": [
		46810,
		6810
	],
	"./sidebar/dashboard.svg": [
		62842,
		2842
	],
	"./sidebar/discount.svg": [
		26380,
		6380
	],
	"./sidebar/messages.svg": [
		25591,
		5591
	],
	"./sidebar/organizations.svg": [
		67010,
		7010
	],
	"./sidebar/profile.svg": [
		2407,
		2407
	],
	"./sidebar/reports.svg": [
		8303,
		8303
	],
	"./sidebar/restaurant.svg": [
		36412,
		6412
	],
	"./sidebar/scan.svg": [
		77395,
		7395
	],
	"./sidebar/scores.svg": [
		71406,
		1406
	],
	"./sidebar/settings.svg": [
		7963,
		7963
	],
	"./sidebar/social-networks.svg": [
		49249,
		9249
	],
	"./smartIcon.svg": [
		82850,
		2850
	],
	"./speakerIcon.svg": [
		81403,
		1403
	],
	"./stack_gray.svg": [
		74044,
		4044
	],
	"./stack_ic.svg": [
		65613,
		5613
	],
	"./stack_ic_blue.svg": [
		71753,
		1753
	],
	"./star-fill.svg": [
		55963,
		5963
	],
	"./star-half.svg": [
		21460,
		1460
	],
	"./star.svg": [
		41675,
		1675
	],
	"./starGray.svg": [
		51895,
		1895
	],
	"./starIcon.svg": [
		52674,
		2674
	],
	"./starIconWhite.svg": [
		90491,
		491
	],
	"./starIconYellow.svg": [
		25951,
		5951
	],
	"./star_blue.svg": [
		88053,
		363
	],
	"./star_gray.svg": [
		16913,
		6913
	],
	"./star_m.svg": [
		88586,
		8586
	],
	"./statusIcon.svg": [
		19108,
		9108
	],
	"./tableFiltericon.svg": [
		9372,
		9372
	],
	"./target.svg": [
		25209,
		5209
	],
	"./three-coin-icon.svg": [
		8996,
		8996
	],
	"./time.svg": [
		14637,
		4637
	],
	"./time_blue.svg": [
		60619,
		619
	],
	"./time_gray.svg": [
		25883,
		5883
	],
	"./time_v.svg": [
		27541,
		7541
	],
	"./trash.svg": [
		92956,
		2956
	],
	"./trashIcon.svg": [
		88409,
		8409
	],
	"./trashIconBlue.svg": [
		4222,
		4222
	],
	"./two-color-user.svg": [
		49212,
		9212
	],
	"./user-icon.svg": [
		78642,
		8642
	],
	"./user.svg": [
		43970,
		3970
	],
	"./userEditIcon.svg": [
		75085,
		5085
	],
	"./userIcon.svg": [
		39920,
		9920
	],
	"./userSmallIcon.svg": [
		97601,
		7601
	],
	"./user_messages_ic.svg": [
		39215,
		9215
	],
	"./voiceIcon.svg": [
		44283,
		4283
	],
	"./walletIcon.svg": [
		33208,
		3208
	],
	"./wallet_coins.svg": [
		42070,
		2070
	],
	"./wallet_mo.svg": [
		22139,
		2139
	],
	"./windowIcon.svg": [
		77123,
		7123
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 92073;
module.exports = webpackAsyncContext;